import { useEffect } from "react";

interface Props {
  isOpen: boolean;
  isLoading: boolean;
  error: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmModal: React.FC<Props> = ({
  isOpen,
  isLoading,
  error,
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === "Escape" && !isLoading) onCancel();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, isLoading, onCancel]);

  return (
    <div
      className={`modal-overlay${isOpen ? " is-open" : ""}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modalTitle"
    >
      <div className="modal">
        <h2 className="modal__title" id="modalTitle">
          Antes de confirmar, leia com atenção.
        </h2>

        <p className="modal__text">
          A mudança para o novo preço será aplicada{" "}
          <strong>de imediato</strong>. A semana em curso já passa a valer no
          novo formato e o novo valor aparecerá na sua próxima cobrança.
        </p>

        <div className="modal__warning">
          <strong>Esta ação é irreversível.</strong>
          <br />
          Uma vez confirmada, não será possível voltar para o preço antigo.
        </div>

        {error && (
          <div className="form__error">
            <strong>Não foi possível concluir.</strong>
            <br />
            {error}
          </div>
        )}

        <div className="modal__actions">
          <button
            type="button"
            className="btn btn--primary"
            onClick={onConfirm}
            disabled={isLoading}
          >
            <span className="btn-label">
              {isLoading ? "Confirmando…" : "Sim, confirmar migração"}
            </span>
          </button>
          <button
            type="button"
            className="btn btn--ghost"
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};
